import { useEffect, useState } from 'react'

import MessageBox from '../UI/Modals/MessageBox'
import ButtonM from '../UI/Buttons/Buttons/ButtonM'
import {
  readDbUpdateWarning,
  clearDbUpdateWarning,
  DB_UPDATE_WARNING_EVENT,
} from '../../functions/dbUpdateWarning'
import classes from './DbUpdateWarning.module.css'

/** DES-21986: shows the "database update did not complete" warning saved at login. */
const DbUpdateWarning = () => {
  const [message, setMessage] = useState(readDbUpdateWarning)

  useEffect(() => {
    const show = () => setMessage(readDbUpdateWarning())
    window.addEventListener(DB_UPDATE_WARNING_EVENT, show)
    return () => window.removeEventListener(DB_UPDATE_WARNING_EVENT, show)
  }, [])

  if (!message) {
    return null
  }

  const close = () => {
    clearDbUpdateWarning()
    setMessage('')
  }

  return (
    <MessageBox title="Database update" onClose={close}>
      <p className={classes.message} data-testid="db-update-warning-message">{message}</p>
      <ButtonM onClick={close} data-testid="db-update-warning-ok">OK</ButtonM>
    </MessageBox>
  )
}

export default DbUpdateWarning
